import { Container, Input, Label } from './SwitchButton.styles';
import React from 'react';

interface IOption {
  value: string;
  dataTestId: string;
}
export interface Props {
  selectedOption: string;
  options: IOption[];
  setSelectedOption: (option: IOption) => void;
  name: string;
}

export const SwitchButton = ({
  options,
  selectedOption,
  setSelectedOption,
  name,
}: Props) => (
  <Container>
    {options.map((option) => (
      <React.Fragment key={option.value}>
        <Input
          type={'radio'}
          id={option.value}
          name={name}
          checked={selectedOption === option.value}
          readOnly
        />
        <Label
          htmlFor={option.value}
          data-testid={option.dataTestId}
          onClick={() => setSelectedOption(option)}
        >
          {option.value}
        </Label>
      </React.Fragment>
    ))}
  </Container>
);
